export default "__VITE_ASSET___okh8E$E__"